/* eslint-disable */
import React from 'react';
import Layout from '../../components/Layout';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';
import getCloudinary from '../../utils/getCloudinary';

const StockistsPage = () => {
    const [showStockist, setShowStockist] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => setShowStockist(true), 500)
    }, [])
    return (
    <Layout id="stockists-page">
        <SEO title="DR WATSON CBD Stockists | Find your nearest CBD stockist" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content">

            <div className='stockist-header-banner is-theme-info'>
                <div className="title is-size-3-touch is-size-2-desktop has-text-white">
                    Find your nearest stockist
                </div>
                <div className="subtitle is-size-5-touch is-size-4-desktop has-text-white">
                    We are growing fast and may already be in a store near you!
                </div>
            </div>
          <div className="store-locator">
              <div data-stockist-widget-tag="u5214" style={{ padding: '5rem 2rem' }}>
                  <progress className="progress is-medium is-info" max="100">15%</progress>
              </div>
              {
                  showStockist && (
                      <script>
                          {
                              (function (s, t, o, c, k) {
                                  c = s.createElement(t); c.src = o; c.async = 1;
                                  k = s.getElementsByTagName(t)[0]; k.parentNode.insertBefore(c, k);
                              }(document, 'script', '//stockist.co/embed/v1/widget.min.js'))
                          }
                      </script>
                  )
              }
          </div>
        </div>
        <Footer />

    </Layout>
)};

export default StockistsPage;
